/**
 * Dashboard API
 *
 * API methods for dashboard statistics.
 */

import { api } from './client';
import type { DashboardStats, DailyMockupsReport } from '../types';

/**
 * Get dashboard statistics
 * Returns stage counts, mockup metrics, approval timing, invoice status, and revenue
 */
export async function getDashboardStats(): Promise<DashboardStats> {
  return api.get<DashboardStats>('/dashboard/stats');
}

/**
 * Backfill prices for existing orders (one-time admin action)
 */
export async function backfillPrices(): Promise<{ success: boolean; updated: number; totalChecked: number }> {
  return api.post('/dashboard/backfill-prices', {});
}

/**
 * Get daily mockup counts for the report chart
 */
export async function getDailyMockups(country?: string): Promise<DailyMockupsReport> {
  return api.get<DailyMockupsReport>('/reports/daily-mockups', country ? { country } : undefined);
}
